export function getUserFields(key) {
  const attrs = [
    "id",
    "first_name",
    "last_name",
    "avatar",
    "user.role.id",
    "user.status",
    "user.role.name",
    "department.name",
    "grade",
    "grade.id",
    "grade.name",
  ];

  if (!key) {
    return attrs;
  }

  const fields = {
    [key]: attrs,
  };
  return fields;
}

export function getdirectusUserFields(key) {
  const attrs = [
    "id",
    "first_name",
    "last_name",
    "avatar",
    "employees.id",
  ];

  if (!key) {
    return attrs;
  }

  const fields = {
    [key]: attrs,
  };
  return fields;
}

export function getEmployeeFields(key) {
  const attrs = [
    "id",
    "first_name",
    "last_name",
    "avatar",
    "user.id",
    "grade.name",
    "department.name"
  ];

  if (!key) {
    return attrs;
  }

  const fields = {
    [key]: attrs,
  };
  return fields;
}
